import { type IconName, iconNames } from "@rally/ui-kit";

const CAN_DRAW = new Set<string>(iconNames);

export function glyphOf(icon: string | null): IconName {
  return icon && CAN_DRAW.has(icon) ? (icon as IconName) : "message-square";
}
